import {SortingState} from '@tanstack/table-core';
import {useCallback, useState} from 'react';

const INITIAL_SORTING: SortingState = [{id: 'appliedDate', desc: true}];

export interface CreatorsTabState {
  sorting: SortingState;
  setSorting: (sorting: SortingState) => void;
  resetSorting: () => void;
}

function useCreatorsTabState(): CreatorsTabState {
  const [sorting, setSortingState] = useState<SortingState>(INITIAL_SORTING);

  const setSorting = useCallback((newSorting: SortingState) => {
    setSortingState(newSorting);
  }, []);

  const resetSorting = useCallback(() => {
    setSortingState(INITIAL_SORTING);
  }, []);

  return {
    sorting,
    setSorting,
    resetSorting,
  };
}

export default useCreatorsTabState;
